export default "__VITE_ASSET__DUFj2UpI__"